var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "table-responsive" }, [
      _c(
        "table",
        { staticClass: "table table-bordered table-happy nomargin" },
        [
          _vm._m(1),
          _c(
            "tbody",
            [
              _vm.listLadings.length > 0
                ? _vm._l(_vm.listLadings, function(item, index) {
                    return _c(
                      "tr",
                      { key: index, class: { error: !item.isValid } },
                      [
                        _c("td", { staticClass: "col-mid" }, [
                          _vm._v(_vm._s(index + 1))
                        ]),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.binCode,
                                expression: "item.binCode"
                              },
                              {
                                name: "watchControl",
                                rawName: "v-watchControl",
                                value: function() {
                                  _vm.checkValid()
                                },
                                expression: "() => { checkValid() }"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", placeholder: "Mã vận đơn" },
                            domProps: { value: item.binCode },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(item, "binCode", $event.target.value)
                              }
                            }
                          })
                        ]),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.productName,
                                expression: "item.productName"
                              },
                              {
                                name: "watchControl",
                                rawName: "v-watchControl",
                                value: function() {
                                  _vm.checkValid()
                                },
                                expression: "() => { checkValid() }"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Tên sản phẩm"
                            },
                            domProps: { value: item.productName },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  item,
                                  "productName",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _c("td", { staticClass: "col-mid" }, [
                          _vm.listLadings.length > 1
                            ? _c(
                                "a",
                                {
                                  staticClass: "text-danger",
                                  attrs: { href: "javascript: void(0)" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeRow(item.id)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-remove" })]
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  })
                : _vm._e(),
              [
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "text-right", attrs: { colspan: "5" } },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          class: {
                            disable: this.listLadings.length >= _vm.limit
                          },
                          attrs: { href: "javascript: void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.addRow()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus" }),
                          _vm._v(" Thêm mới")
                        ]
                      )
                    ]
                  )
                ])
              ]
            ],
            2
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [_vm._v("Danh sách vận đơn")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "w50" }, [_vm._v("STT")]),
        _c("th", { staticClass: "m-w200" }, [_vm._v("Mã vận đơn")]),
        _c("th", [_vm._v("Tên sản phẩm")]),
        _c("th", { staticClass: "w45" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }